import React from 'react';
import { HStack, Tag, TagLabel, TagLeftIcon } from '@chakra-ui/react';
import { useTokens } from '../../../context/TokenProvider';
import { RenderIf } from '../RenderIf/RenderIf';
import CheckIcon from '../../icons/CheckIcon/CheckIcon';
const MultiSelectChip = ({ chip, category, onChipClicked, handleKeyDown, ...rest }) => {
    const tokens = useTokens();
    const onClickedProxy = () => {
        if (!category || !onChipClicked)
            return;
        onChipClicked(category, chip);
    };
    return (React.createElement(Tag, { "data-testid": "multi_select_chip", onClick: onClickedProxy, tabIndex: 0, onKeyDown: handleKeyDown, cursor: "pointer", "data-category": category?.key, _hover: { transform: 'scale(1.05)' }, _active: { transform: 'scale(1)' }, variant: chip.isSelected ? 'green-selected' : 'green', ...rest },
        React.createElement(HStack, { justifyContent: "space-between", gap: tokens.Spacing02 },
            React.createElement(RenderIf, { condition: !!chip.isSelected },
                React.createElement(TagLeftIcon, { as: CheckIcon, "data-testid": "multi_select_chip_check_icon", mr: 0 })),
            React.createElement(TagLabel, { "data-testid": "multi_select_chip_text" }, chip.text))));
};
export default MultiSelectChip;
